import { useCallback, useState } from "react";

/**
 * 스크롤 위치에 따라 현재 보이는 섹션 ID를 반환하는 훅
 *
 * 사용법:
 *   const { activeId, observeRef } = useScrollSpy("introduction");
 *   <section ref={observeRef}>...</section>
 */
export function useScrollSpy(defaultId: string) {
  const [activeId, setActiveId] = useState(defaultId);

  const observeRef = useCallback((node: HTMLElement | null) => {
    if (!node) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const intersecting = entries.find((entry) => entry.isIntersecting);
        if (intersecting) {
          setActiveId(intersecting.target.id);
        }
      },
      {
        // -124px: 상단 sticky 헤더 + 높이만큼 무시
        // -60%: 뷰포트 하단 60%는 무시 → 상단 40%에 들어올 때 전환
        rootMargin: "-124px 0px -60% 0px",
        threshold: 0,
      }
    );

    observer.observe(node);

    // 요소가 제거될 때 observer 해제
    return () => {
      observer.disconnect();
    };
  }, []);

  return { activeId, observeRef };
}
